import { render, staticRenderFns } from "./UploadingDetails.vue?vue&type=template&id=bbe494aa&scoped=true&"
import script from "./UploadingDetails.vue?vue&type=script&lang=js&"
export * from "./UploadingDetails.vue?vue&type=script&lang=js&"
import style0 from "./UploadingDetails.css?vue&type=style&index=0&id=bbe494aa&prod&scoped=true&lang=css&"
import style1 from "./UploadingDetails.vue?vue&type=style&index=1&id=bbe494aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe494aa",
  null
  
)

export default component.exports